import './_jquery';
import MobileDetect from 'mobile-detect'
const md = new MobileDetect(window.navigator.userAgent);

jQuery(function() {
  let AreaPartner, canComposeUrl, closeModal, composeUrl, createOptionTag, modal, openModal, orderSpecializzazioni, removeChildren, selectDistrictTag, selectMarketTag, selectRegionTag, selectSpecializationTag, selectUpdateButton, updateDataSelected, updateHrefOf, updateSelectDistrict, updateSelectFilter, updateSelectSpecializzazione;

  AreaPartner = {};
  AreaPartner.allMarkets = {
    'MERCATO_IMPRESA': 'Impresa',
    'MERCATO_STUDIO': 'Studio'
  };
  AreaPartner.allSpecializations = {
    'Specializzazione_ENOLOGIA': 'Enologia',
    'Specializzazione_JOB-Risorse': 'JOB/Risorse',
    'Specializzazione_MARMI': 'Marmi',
    'Specializzazione_MODA': 'Moda',
    'Specializzazione_MOTORI': 'Motori',
    'Specializzazione_OLEARIO': 'Oleario',
    'Specializzazione_Studi Legali': 'Studi Legali',
    'Specializzazione_TRASPORTI': 'Trasporti'
  };

  window.AreaPartner = AreaPartner;

  selectRegionTag = document.getElementById('select-region');
  selectDistrictTag = document.getElementById('select-district');
  selectMarketTag = document.getElementById('select-market');
  selectSpecializationTag = document.getElementById('select-specialization');
  selectUpdateButton = document.getElementById('select-button');

  // Scroll if the partners are present
  if (md.mobile()) {
    if ($('[data-marker-count]').data('marker-count') > 0) {
      document.querySelector('#google_map__box').scrollIntoView({
        behavior: 'smooth'
      });
    }
  }

  canComposeUrl = function(currentEvent, selection) {
    return currentEvent.target === selection && currentEvent.target.value !== '' && selection.value !== '';
  };

  updateDataSelected = function(target) {
    if (target.value === 'all' || target.value === '') {
      target.setAttribute('data-selected', '');
    } else {
      target.setAttribute('data-selected', target.value);
    }
  };

  composeUrl = function(event) {
    let baseUrl, basename;
    basename = window.location.origin + '/partner/';

    updateDataSelected(event.target);

    if (canComposeUrl(event, selectRegionTag)) {
      updateSelectDistrict(event.target);
      updateSelectFilter(event.target, 'Mercato', selectMarketTag);
      // updateSelectFilter(
      //   event.target,
      //   'Specializzazione',
      //   selectSpecializationTag
      // )
    }

    if (canComposeUrl(event, selectMarketTag)) {
      updateSelectSpecializzazione(event.target);
    }

    baseUrl = basename + [selectRegionTag.value, selectDistrictTag.value, selectMarketTag.value, selectSpecializationTag.value].join('/');
    return updateHrefOf(selectUpdateButton, baseUrl);
  };

  updateSelectDistrict = function(target) {
    let districts, region;

    removeChildren(selectDistrictTag);

    region = AreaPartner.parsedData.find(function(region) {
      return region.name === target.value;
    });

    if (target.value === 'all' || target.value === '') {
      districts = [];
    } else {
      districts = region.provinces;
    }

    return Object.keys(districts).forEach(function(district) {
      let selected;
      selected = false;

      if (selectDistrictTag.getAttribute('data-selected') === district) {
        selected = true;
      }
      return createOptionTag(selectDistrictTag, district, region.provinces[district], selected);
    });
  };

  updateSelectSpecializzazione = function(target) {
    let mercato;
    removeChildren(selectSpecializationTag);

    mercato = target.getAttribute('data-selected').replace('_', ' ');

    return Object.values(AreaPartner.parsedSpecializzazioni).forEach(function(spec) {
      let selected;

      if (spec.Mercato === mercato || mercato.trim() === '') {
        if (selectSpecializationTag.getAttribute('data-selected') === spec.CodiceAssegnazione) {
          selected = true;
        }
        return createOptionTag(selectSpecializationTag, spec.CodiceAssegnazione, spec.Descrizione, selected);
      }
    });
  };

  updateSelectFilter = function(target, filterType, selectTag) {
    let collection;

    removeChildren(selectTag);

    if (target.value === 'all' || target.value === '') {
      collection = [];
    } else {
      if (filterType === 'Mercato') {
        collection = AreaPartner.allMarkets;
      } else if (filterType === 'Specializzazione') {
        collection = AreaPartner.allSpecializations;
      } else {
        collection = [];
      }
    }

    return Object.keys(collection).forEach(function(element) {
      let selected;
      selected = false;
      if (selectTag.getAttribute('data-selected') === element) {
        selected = true;
      }
      return createOptionTag(selectTag, element, collection[element], selected);
    });
  };

  removeChildren = function(parent) {
    let results;
    results = [];

    while (parent.lastChild && parent.lastChild.value !== 'all') {
      results.push(parent.removeChild(parent.lastChild));
    }

    return results;
  };

  updateHrefOf = function(el, value) {
    return el.setAttribute('href', value);
  };

  createOptionTag = function(parentTag, value, label, selected) {
    let optionTag, textNode;

    if (selected === null || selected === void 0) {
      selected = false;
    }

    optionTag = document.createElement("option");

    if (selected) {
      optionTag.setAttribute('selected', '');
    }

    optionTag.setAttribute('value', value);

    if (parentTag != null) {
      textNode = document.createTextNode(label);
      optionTag.appendChild(textNode);
      parentTag.appendChild(optionTag);
    }

    return optionTag;
  };

  $.getJSON(window.location.origin + '/wp-json/area-partner/v1/regioni.json', function(data) {
    let event;

    AreaPartner.parsedData = data;

    createOptionTag(selectRegionTag, 'all', 'Regione');
    createOptionTag(selectDistrictTag, 'all', 'Provincia');
    createOptionTag(selectMarketTag, 'all', 'Mercato');
    // createOptionTag(selectSpecializationTag, 'all', 'Specializzazione')

    AreaPartner.parsedData.forEach(function(region) {
      let selected;
      selected = false;
      if (selectRegionTag != null) {
        if (selectRegionTag.getAttribute('data-selected') === region.name) {
          selected = true;
        }
      }
      return createOptionTag(selectRegionTag, region.name, region.label, selected);
    });

    // NOTE: (AF) grazie ad un bug ho capito il motivo per cui veniva fatto un dispatch manuale
    //       di un evento. Il punto è triggerare al primo caricamento della pagina l'aggiornamento
    //       di tutte le select che sono da popolare.
    //       Mi pare anche che, come dicevo nel commento precedente che cancello con questo
    //       commit, non ci fosse necessità di lanciarlo decine e decine di volte. Qui viene
    //       lanciato solo una volta dopo il caricamento dei dati, successivamente sarà il browser
    //       ha lanciare il change della select.
    //       Ho optato per lasciare solo questa vecchia sintassi per non lanciare due volte
    //       solo per avere un metodo per i vecchi browser ed uno per i nuovi. Per quanto deprecata
    //       questa API (initEvent) ad oggi non è stata rimossa dai browser evergreen.
    //       ref: https://developer.mozilla.org/en-US/docs/Web/API/Event/initEvent
    event = document.createEvent("Event");
    event.initEvent("change", false, true);
    return selectRegionTag.dispatchEvent(event);
  });

  // Specifica richiesta del cliente.
  // Il desiderata é avere le voci della specializzazione in ordine di mercato (studio e poi impresa) le cui voci interne
  // ordinate in ordine alfabetico.
  // cit da chat. "si possono mettere prima le specializzazione del mercato studio (in ordine alfabetico) e poi le
  // specializzazioni del mercato azienda (sempre in ordine alfabetico)?"

  // Quindi abbiamo prima una separazione a livello di mercato
  // Una volta "raggruppati" si effettua un ordinamento alfabetico
  orderSpecializzazioni = function(specs) {
    let ordered_specs;
    ordered_specs = {};

    // Raggruppamento per mercato
    ['MERCATO STUDIO', 'MERCATO IMPRESA'].forEach(function(mercato) {
      let tmp_specs;
      tmp_specs = {};
      Object.entries(specs).forEach(function(spec) {
        if (spec[1].Mercato === mercato) {
          return tmp_specs[spec[0]] = spec[1];
        }
      });

      // Ordinamento alfabetico all'interno del raggruppamento per mercato
      tmp_specs = Object.entries(tmp_specs).sort(function(a, b) {
        let desc_a, desc_b;
        desc_a = a[1].Descrizione.toLowerCase();
        desc_b = b[1].Descrizione.toLowerCase();
        if (desc_a < desc_b) {
          return -1;
        }
      });

      // Popolo ordered specs
      return Object.entries(tmp_specs).forEach(function(spec) {
        return ordered_specs[spec[1][0]] = spec[1][1];
      });
    });

    return ordered_specs;
  };

  $.getJSON(window.location.origin + '/wp-json/area-partner/v1/specializzazioni.json', function(data) {
    let event;

    AreaPartner.parsedSpecializzazioni = orderSpecializzazioni(data);

    createOptionTag(selectSpecializationTag, 'all', 'Specializzazione');

    // NOTA: Vedere stessa nota di sopra
    event = document.createEvent("Event");
    event.initEvent("change", false, true);
    selectMarketTag.dispatchEvent(event);
  });

  modal = $("#empty-region-modal");

  openModal = function() {
    modal.addClass("display-modal");
    setTimeout(function() {
      modal.addClass("transition-modal");
    }, 5);
  };

  closeModal = function() {
    modal.removeClass("transition-modal");
    setTimeout(function() {
      modal.removeClass("display-modal");
    }, 200);
  };

  $("#empty-region-modal__close").on('click', function() {
    closeModal();
  });

  $('#select-button').on('click', function(event) {
    if (!$('#select-region').val() || $('#select-region').val() === 'all') {
      event.preventDefault();
      openModal();
    }
  });

  if (selectRegionTag != null) {
    selectRegionTag.addEventListener('change', composeUrl);
  }

  if (selectDistrictTag != null) {
    selectDistrictTag.addEventListener('change', composeUrl);
  }

  if (selectMarketTag != null) {
    selectMarketTag.addEventListener('change', composeUrl);
  }

  if (selectSpecializationTag != null) {
    selectSpecializationTag.addEventListener('change', composeUrl);
  }
});
